// extracted by mini-css-extract-plugin
module.exports = {"PageHolder":"RestaurantsList_PageHolder__2u1kO","ListHolder":"RestaurantsList_ListHolder__57Uks","FixPage":"RestaurantsList_FixPage__11o9C"};